import { render, staticRenderFns } from "./BusinessNameFormFiles.vue?vue&type=template&id=54f81879&scoped=true&"
import script from "./BusinessNameFormFiles.vue?vue&type=script&lang=js&"
export * from "./BusinessNameFormFiles.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNameFormFiles.vue?vue&type=style&index=0&id=54f81879&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f81879",
  null
  
)

export default component.exports